import SaleAnalyticsChart from './SaleAnalyticsChart'
import { withSaleAnalyticsChart } from './withSaleAnalyticsChart'

const ConnectedSaleAnalyticsChart = withSaleAnalyticsChart(SaleAnalyticsChart)

export { ConnectedSaleAnalyticsChart as SaleAnalyticsChart }
